import { SELECT, SWITCH, TEXT } from "../../components/Common/Const";

export const APIEndpointConst = [
  {
    name: "serviceType",
    label: "Service Type",
    options: [
      { label: "Select Service Type", value: "0" },
      { label: "clientAPI", value: 1 },
      { label: "dataProviderAPI", value: 2 },
      { label: "entitySport", value:3 },
    ],
    isRequired: true,
    type: SELECT,
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "endPoint",
    label: "EndPoint",
    type: TEXT,
    isRequired: true,
    requiredErrorMessage: "Please enter EndPoint.",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "moduleType",
    label: "Module Type",
    options: [
      { label: "Select Module Type", value: "0" },
      { label: "commentaryUpdate", value: 1 },
      { label: "vendorUpdate", value: 2 },
      { label: "vendorIpUpdate", value: 3 },
      { label: "updateConfig", value: 4 },
      { label: "updateBanner", value: 5 },
      { label: "updateSeoModule", value: 6 },
      { label: "updateMenuList", value: 7 },
      { label: "getICCRankingData", value: 9 },
      { label: "insertTeam", value: 10 },
      { label: "insertPlayer", value: 11 },
      { label: "getSocketCount", value: 12 },
      { label: "getCompetitionInfo", value: 13 },
      { label: "getTeamDataByIdFromEntity", value: 14 },
      { label: "getPlayerDataByIdFromEntity", value: 15 },
      { label: "getMatchDataByIdFromEntity", value: 16 },
      { label: "getCompetitionMatchDataByIdFromEntity", value: 17 },
      { label: "getCompetitionSquadDataByIdFromEntity", value: 18 },
      { label: "searchPlayerDataFromEntity", value: 19 },
      { label: "getCommentaryInningDataFromEntity", value: 20 },
      { label: "upsertAdvertiseDataToClient", value: 21},
    ],
    isRequired: true,
    type: SELECT,
    defaultValue: false,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "timeOut",
    label: "TimeOut",
    type: TEXT,
    isRequired: true,
    requiredErrorMessage: "Please enter TimeOut.",
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
  {
    name: "isActive",
    label: "Is Active",
    parentclassName: "",
    defaultValue: true,
    type: SWITCH,
    labelColspan: { xs: 12, md: 2, lg: 2 },
    fieldColspan: { xs: 12, md: 4, lg: 4 },
  },
];
